<template>
  <div id="app"
    class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover appHomeList">
    <HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <div class="post-content">
            <div class="post-content-inner">
              <div class="content-inner">
                <h1 class="free-download-title">GBWhatsApp 2026|GB WhatsApp Download APK V18.80-FREE</h1>
                <div>
                  <div class="features-list-icon">? GB WhatsApp offers advanced privacy features like hiding online
                    status and blue ticks.</div>
                  <div class="features-list-icon">
                    ? You can use two WhatsApp accounts on one device easily.
                  </div>
                  <div class="features-list-icon">? GB WhatsApp is supported on Android devices.</div>
                </div>
                <div>
                  <button class="free-download-btn" @click="jump('https://gbmodshub.com/download-devices/')">Download Latest GBWhatsApp</button>
                  <button class="free-download-btn1"
                    @click="jump('https://gbmodshub.com/gbwhatsapp-old-version/')">GBWhatsApp Old Version</button>
                </div>
                <div style="color: rgb(101 101 101);">
                  Applicable to <span style="color: #000;">Android phones, PCs, and MACs</span>
                </div>
              </div>
              <div>
                <img src="@/assets/gbwhatsapp512.webp" alt="WhatsApp Download APK  V18.80">
              </div>
            </div>
          </div>
          <div class="release-note">
            <div class="Release-new-note">
              <div>
                <h2 class="intro-title blog">New Release: GB WhatsApp Update V18.80</h2>
                <div>
                  <strong>GB WhatsApp</strong> is updated regularly to bring new features, bug fixes, and enhanced
                  security. To make sure you're always using GBWhatsApp latest version-Try It Now?
                </div>
              </div>
              <div>
                <button class="learn-more-btn"
                  @click="jump('https://gbmodshub.com/gb-whatsapp-v18.60-released-fixed-banned-numbers/')">Learn More</button>
              </div>
            </div>
          </div>

          <div class="post-content introducing">
            <div class="post-content-inner">
              <div class="img-inner">
                <img src="@/assets/Introducing-GBWhatsApp.webp" alt="WhatsApp Download APK  V18.60" class="screenshot">
              </div>
              <div class="introducing-inner">
                <h2 class="intro-title blog">What is GB WhatsApp</h2>
                <div class="introducing-text">Explore <a href="https://gbmodshub.com/" class="jump-url">GBWhatsApp</a>, the powerful WhatsApp MOD that unlocks advanced
                  privacy
                  controls, custom themes, and exclusive features not available in the official app. Let's find out
                  what's
                  good about gbwhatsapp? How to use it? What does the interface look like?</div>
                <div class="learn-more-div" @click="jump('https://gbmodshub.com/news/what-is-gbwhatsapp/')">Learn more >></div>
              </div>
            </div>
          </div>
          <div class="apk-download-section figure-table-list">
            <h2 class="intro-title blog">GB WhatsApp App Info</h2>
            <div class="discover-features">
              GBWhatsApp App gives users more control over their messaging experience. It's no surprise that millions of
              people prefer downloading GBWhatsApp over the standard version for its extra functionality and freedom. If
              you're looking for a better WhatsApp experience, GBWhatsApp is worth trying.
            </div>
            <div class="discover-security">
              <div class="figure-table">
                <figure class="wp-block-table">
                  <table>
                    <tr>
                      <th>App Name</th>
                      <th>GBWhatsApp</th>
                    </tr>
                    <tr>
                      <td>Size</td>
                      <td>80MB</td>
                    </tr>
                    <tr>
                      <td>Version</td>
                      <td>18.80</td>
                    </tr>
                    <tr>
                      <td>Developer</td>
                      <td>Alexmods</td>
                    </tr>
                    <tr>
                      <td>Support OS</td>
                      <td>Android 5.0+</td>
                    </tr>
                    <tr>
                      <td>Last Updated</td>
                      <td>Two days ago</td>
                    </tr>
                  </table>
                </figure>
                <button class="free-download-btn2" @click="jump('https://gbmodshub.com/download-devices/')">Download GBWhatsApp APK</button>
              </div>
              <div class="figure-table-img">
                <img src="@/assets/GWhatsApp-App-Info.webp" alt="" style="height: 320px;">
              </div>
            </div>
          </div>
          <!-- ???? -->
          <div class="features-section">
            <h2 class="intro-title blog">Top Features of GB WhatsApp (2026)</h2>
            <div class="discover-features">
              Discover the top features of <strong><a href="https://gbmodshub.com/" class="jump-url">GB WhatsApp</a></strong> in 2026, the ultimate <strong>WhatsApp
                mod</strong> for customization, privacy,
              and enhanced functionality. Enjoy features like hiding last seen, dual WhatsApp accounts, larger file
              sharing, self-destruct messages, and status downloads. With built-in app lock and advanced anti-ban
              features, <strong>GBWhatsApp</strong> keeps your chats secure and private. Looking to experience it
              yourself? Get started
              today with <strong>GB WhatsApp Download</strong> and unlock the full potential of this powerful WhatsApp
              alternative!
            </div>
            <div class="features-list">
              <!--  -->
              <div v-for="(item, index) in featuresList" :key="index" class="feature-item" @click="jump(item.link)">
                <div class="feature-title">
                  <img :src="item.img" alt="">
                </div>
                <div>
                  <strong>{{ item.title }}</strong>
                </div>
                <div class="feature-desc">{{ item.desc }}</div>
              </div>
            </div>
            <div class="model-btn">
              <button class="free-download-btn2" @click="jump('https://gbmodshub.com/gb-whatsapp-features/')">Explore More GB WhatsApp Features</button>
            </div>
          </div>
          <!-- ???? -->
          <div class="apk-download-section">
            <h2 class="intro-title "> GB WhatsApp APK Downlod</h2>
            <div class="discover-features">
              Download the latest GB WhatsApp APK for Android phones, tablets, and PCs. Follow our full setup guide to
              install GBWhatsApp easily and enjoy advanced features like dual accounts, enhanced privacy, and custom
              themes. Safe and updated for 2026!
            </div>
            <div class="advanced-list">
              <div class="advanced-item" @click="jump('https://gbmodshub.com/download/gb-whatsapp-android/')">
                <h3><a href="https://gbmodshub.com/download/gb-whatsapp-android/" class="jump-link">Download GB WhatsApp for Android Phone</a></h3>
                <div>
                  Download the latest version of GB WhatsApp for Android phones in 2026! Learn how to easily install GB
                  WhatsApp on your Android device, whether you're using Android 13, 14, 15, or earlier versions.
                </div>
                <div>
                  <img src="@/assets/GB-WhatsApp-for-andriod.webp" alt="GB WhatsApp for andriod">
                </div>

              </div>
              <div class="advanced-item" @click="jump('https://gbmodshub.com/download/gb-whatsapp-pc/')">
                <h3><a href="https://gbmodshub.com/download/gb-whatsapp-pc/" class="jump-link">Download GB WhatsApp For PC or Mac </a></h3>
                <div>
                  Get GB WhatsApp on your PC or Mac in 2026! Follow our simple guide to Download and install GB WhatsApp
                  on Windows 7, 8, 10, 11, and all Mac devices effortlessly.
                </div>
                <div>
                  <img src="@/assets/GB-WhatsApp-for-pc.webp" alt="GB WhatsApp for pc">
                </div>
              </div>
              <div class="advanced-item"  @click="jump('https://gbmodshub.com/download/gb-whatsapp-web/')">
                <h3><a href="https://gbmodshub.com/download/gb-whatsapp-web/" class="jump-link">Download GB Whatsapp For Web </a></h3>
                <div>
                  Download and install GB WhatsApp on the web! Follow our easy guide to get the latest version of GB
                  WhatsApp on the web,
                  The most effective way is by using an Android emulator such as BlueStacks or Nox Player.
                </div>
                <div>
                  <img src="@/assets/GB-WhatsApp-Web.webp" alt="GB WhatsApp Web " style="opacity: 0.7;">
                </div>
              </div>
            </div>
          </div>
          <!-- ???? -->
          <div class="apk-download-section">
            <h2 class="intro-title" id="how-to-download-install-gb">How to Download and Install GB hatsApp Safely on Your phone</h2>
            <div class="discover-security">
              <div class="discover-img">
                <img src="@/assets/Safely-on-Your-Phone.webp" alt="Safely on Your Phone">
              </div>
              <div class="discover-text-div">
                <ul class="discover-ul">
                  <li> Go to Settings > Security, and enable Install from Unknown Sources.</li>
                  <li>Click the button below. Download the GBWhatsApp APK</li>
                  <li><button class="free-download-btn3" @click="jump('https://gbmodshub.com/download-devices/')">Download Now?</button></li>
                  <li> Open the APK file from your Downloads folder.</li>
                  <li> Tap Install to complete the installation.</li>
                  <li> Open GB WhatsApp, verify your number, and start using it!</li>
                </ul>
                <a href="https://gbmodshub.com/how-to-install-gb-whatsapp/" class="jump-link">How to Install GB WhatsApp >></a>
              </div>
            </div>
          </div>
          <!-- ???? -->
          <div class="apk-download-section">
            <h2 class="intro-title">How to Update GB WhatsApp Safely</h2>
            <div class="updated-section">
              <div class="updated-inner">
                <div>
                  <h3>Method 1: Manual Update</h3>
                  <ul>
                    <li> Download the Latest APK: Visit a trusted source to download the latest GB WhatsApp APK.</li>
                    <li> Install Over the Old Version: Open the APK file and install it over your existing GB WhatsApp
                      app. Your chats and settings will remain intact.</li>
                  </ul>
                  <h3>Method 2: Enable Automatic Updates (Via APK Sites)</h3>
                  <ul>
                    <li> Follow Reliable Sources: Make sure you?re downloading updates from our websites.</li>
                    <li> Stay Notified: Enable notifications on the download site to get alerts when new versions are
                      released.</li>
                  </ul>
                </div>
                <a href="https://gbmodshub.com/how-to-update-gb-whatsapp/" class="jump-link">How to Update GB WhatsApp >></a>
              </div>
              <div class="updated-img">
                <img src="@/assets/gb-whatsapp-update.webp" alt="">
              </div>
            </div>
          </div>
          <!-- GB WhatsApp vs Official WhatsApp -->
          <div class="apk-download-section">
            <h2 class="intro-title">GB WhatsApp vs Official WhatsApp</h2>
            <div class="compare-table-wrap">
              <table class="compare-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>GB WhatsApp</th>
                    <th>Official WhatsApp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in compareList" :key="index">
                    <td>{{ row.category }}</td>
                    <td>{{ row.gb }}</td>
                    <td>{{ row.official }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="discover-features compare-summary">
              <strong>Choose GB WhatsApp</strong> if you want more customization and understand the risks of using an
              unofficial app. If account stability, official support, and long-term reliability matter most, official
              WhatsApp is the better choice.
            </div>
          </div>
          <!-- How to Reduce Ban Risk -->
          <div class="apk-download-section">
            <h2 class="intro-title">How to Reduce the Risk of Being Banned on GB WhatsApp</h2>
            <div class="discover-features text-left-block">
              <p>There is no guaranteed way to prevent an account restriction when using GB WhatsApp. Since it is an
                unofficial modified version of WhatsApp, WhatsApp can restrict accounts or change compatibility at any
                time.</p>
              <p>You can still reduce unnecessary risks by following a few basic practices:</p>
              <ul class="home-guide-list">
                <li><strong>Use a current version:</strong> Outdated builds are more likely to have compatibility problems.</li>
                <li><strong>Avoid spam:</strong> Do not send large numbers of unwanted messages or repeatedly contact unknown users.</li>
                <li><strong>Avoid suspicious modifications:</strong> Stick to the features provided by the app rather than using unknown add-ons.</li>
                <li><strong>Keep your account active normally:</strong> Avoid unusual or automated activity that may trigger restrictions.</li>
                <li><strong>Back up your chats:</strong> Keep a recent backup in case you need to switch back to official WhatsApp.</li>
              </ul>
              <p>Most importantly, don't trust claims that an APK offers <strong>100% anti-ban protection</strong>. No
                modified app can guarantee that an account will never be restricted.</p>
            </div>
          </div>
          <!-- What to Do If GB WhatsApp Stops Working -->
          <div class="apk-download-section">
            <h2 class="intro-title">What to Do If GB WhatsApp Stops Working</h2>
            <div class="discover-features text-left-block">
              <p>If GB WhatsApp suddenly stops working, don't immediately uninstall it. First, identify the problem and
                protect your chat history.</p>
              <ol class="home-guide-list">
                <li><strong>Back up your chats</strong><br />If the app still opens, create a local backup before making any changes.</li>
                <li><strong>Check your connection</strong><br />Try switching between Wi-Fi and mobile data and make sure other apps can access the internet.</li>
                <li><strong>Check your version</strong><br />An outdated or expired GB WhatsApp version may stop working after compatibility changes. Check whether a newer release is available.</li>
                <li><strong>Look at the error message</strong><br />Messages such as <strong>?Use the official WhatsApp?</strong>, verification errors, or an expired-version notice can point to different problems.</li>
                <li><strong>Consider switching to official WhatsApp</strong><br />If GB WhatsApp cannot verify your number or continues to stop working after an update, the official WhatsApp app is the more reliable option.</li>
              </ol>
              <p>Always back up important chats before changing or reinstalling the app.</p>
            </div>
          </div>
          <!-- Who Should Choose GB WhatsApp -->
          <div class="apk-download-section">
            <h2 class="intro-title">Who Should Choose GB WhatsApp?</h2>
            <div class="discover-features text-left-block">
              <p>GB WhatsApp is mainly suited to Android users who want more control over the look and behavior of their
                messaging app.</p>
              <p><strong>It may be a good fit if you:</strong></p>
              <ul class="home-guide-list">
                <li>Want more themes and interface customization.</li>
                <li>Prefer additional privacy controls.</li>
                <li>Like having more options than the standard WhatsApp experience.</li>
                <li>Are comfortable using an unofficial third-party app.</li>
                <li>Understand that features and compatibility can change between versions.</li>
              </ul>
              <p><strong>Official WhatsApp may be better if you:</strong></p>
              <ul class="home-guide-list">
                <li>Need official customer support.</li>
                <li>Want the most reliable account experience.</li>
                <li>Prefer automatic updates from the official developer.</li>
                <li>Don't want the additional risks associated with modified apps.</li>
              </ul>
              <p><strong>In short:</strong> GB WhatsApp is about <strong>more flexibility</strong>, while official
                WhatsApp is about <strong>official support and reliability</strong>. The better choice depends on which
                of those matters more to you.</p>
            </div>
          </div>
          <!-- ???? -->
          <div class="apk-download-section">
            <!-- <h2 class="intro-title">Keep GB WhatsApp Updated ? Quick & Safe Methods</h2> -->
            <div class="customization-section">
              <div class="customization-inner">
                <h2 class="intro-title">GB WhatsApp Alternatives</h2>
                <div>
                  If you're looking for alternatives to GB WhatsApp Pro, here are some popular WhatsApp Mods with
                  similar features.These mods allow users to have more control over their WhatsApp experience, from
                  theme customization to advanced privacy features and the ability to use multiple accounts on the same
                  device.
                </div>
                <button class="free-download-btn" @click="jump('https://gbmodshub.com/whatsapp-mods/')">
                  WhatsApp Mods
                </button>
              </div>
              <div class="customization-right">
                <div v-for="item in alternativeList" :key="item.key" class="customization-div">
                  <div class="customization-item"><img :src="item.img" alt="WhatsApp Mods"></div>
                  <div class="customization-text">
                    <h3>{{ item.name }}</h3>
                    <div>{{ item.dec }}</div>
                    <a :href="item.link" class="jump-link">Explore More >></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ???? -->
          <div class="apk-download-section">
            <h2 class="intro-title">FAQs about GBWhatsApp App</h2>
            <div class="discover-features">Here?s a comprehensive FAQ for GB WhatsApp to help users with common issues,
              solutions, and helpful tips:</div>
            <div class="discover-collapse">
              <el-collapse v-model="activeNames">
                <el-collapse-item name="1">
                  <template slot="title">
                    <h3 class="intro-work-title">How to Fix GB WhatsApp Not Working?</h3>
                  </template>
                  <div class="intro-working">If GB WhatsApp isn?t working, try the following solutions:
                    <ul>
                      <li> <strong>Solution 1: Clear Cache and Data</strong>
                        <ul>
                          <li> Go to <strong>Settings > Apps > GB WhatsApp</strong>.</li>
                          <li> Tap on <strong>Storage > Clear Cache and Clear Data</strong>.</li>
                          <li> Restart your phone and try opening GB WhatsApp again.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Solution 2: Check Internet Connection</strong> ensures that your phone has a stable
                        strinternet connection
                        (Wi-Fi or mobile data).
                        GB WhatsApp requires an active internet connection to function properly.
                      </li>
                    </ul>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <h3 class="intro-work-title">How to Backup GB WhatsApp Chats?</h3>
                  </template>
                  <div class="intro-working">
                    <ul>
                      <li>Open <strong>GB WhatsApp</strong> and go to <strong>Settings</strong>.</li>
                      <li> Tap <strong>Chats > Chat Backup</strong>.</li>
                      <li> Tap <strong>Backup</strong> to save chats to Google Drive or local storage.</li>
                    </ul>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="3">
                  <template slot="title">
                    <h3 class="intro-work-title">How to Restore GB WhatsApp Chats?</h3>
                  </template>
                  <div class="intro-working">
                    <ol>
                      <li> Reinstall GB WhatsApp and verify your phone number.</li>
                      <li> When prompted, tap Restore to recover chats from Google Drive or local storage.</li>
                      <li> Wait for the process to complete, and your chats will be restored.</li>
                    </ol>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="4">
                  <template slot="title">
                    <h3 class="intro-work-title">How to Fix GB WhatsApp Banned?</h3>
                  </template>
                  <div class="intro-working">
                    If GB WhatsApp is banned, follow these steps to unban or avoid being banned in the future:
                    <h4>Solution 1: Use an Anti-Ban Version</h4>
                    <ul>
                      <li>
                        Ensure that you?re using an updated version of <strong>GB WhatsApp</strong> with
                        <strong>anti-ban
                          protection</strong>. Many versions of GB WhatsApp have built-in anti-ban features to help
                        prevent account
                        bans.
                      </li>
                    </ul>
                    <h4>Solution 2: Switch to Official WhatsApp</h4>
                    <ul>
                      <li>
                        To avoid being banned in the future, it?s recommended to <strong>switch back to the official
                          WhatsApp</strong>
                        app, as mods like GB WhatsApp are unofficial and might violate WhatsApp?s terms of service.
                      </li>
                    </ul>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="5">
                  <template slot="title">
                    <h3 class="intro-work-title">Is GB WhatsApp Safe to Use in India?</h3>
                  </template>
                  <div class="intro-working">
                    GB WhatsApp is not an official app and is considered to be a modified version of the official
                    WhatsApp. As of now,
                    WhatsApp is taking action against third-party apps like GB WhatsApp, and these apps might be blocked
                    or banned in
                    certain regions, including India.
                  </div>
                </el-collapse-item>
                <el-collapse-item name="6">
                  <template slot="title">
                    <h3 class="intro-work-title">Can I Use GB WhatsApp and Official WhatsApp on the Same Phone?</h3>
                  </template>
                  <div class="intro-working">
                    Yes, <strong>GB WhatsApp</strong> allows users <strong>two use two WhatsApp</strong> accounts on the
                    same device
                    simultaneously. This
                    is one of the key
                    features of GB WhatsApp, and you can have both the official WhatsApp app and GB WhatsApp running on
                    your phone at
                    the same time. Here's how:
                    <ul>
                      <li><strong>Install GB WhatsApp</strong> and the official WhatsApp app on the same device.</li>
                      <li> Use different <strong>phone numbers</strong> for each app (you can either use a <strong>dual
                          SIM
                          phone</strong> or two separate numbers).</li>
                      <li> Both apps will work independently, and you can manage different accounts for personal and
                        work-related
                        purposes.</li>
                    </ul>
                  </div>
                </el-collapse-item>

                <el-collapse-item name="7">
                  <template slot="title">
                    <h3 class="intro-work-title">Can I Restore WhatsApp Chats from Official WhatsApp to GB WhatsApp?
                    </h3>
                  </template>
                  <div class="intro-working">
                    Yes, you can <strong>restore your official WhatsApp chats to GB WhatsApp</strong> if you're
                    switching from the
                    official version. The process is similar to the regular backup and restore method:
                    <ul>
                      <li> Make sure you have a <strong>backup of your WhatsApp chats</strong> (from Google Drive or
                        local storage).
                      </li>
                      <li> Install <strong>GB WhatsApp</strong> and verify your phone number.</li>
                      <li> During setup, <strong>GB WhatsApp</strong> will prompt you to <strong>restore the
                          backup</strong>.</li>
                      <li> Select <strong>Restore</strong> from Google Drive or local storage, and your chats will be
                        transferred.</li>
                    </ul>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="8">
                  <template slot="title">
                    <h3 class="intro-work-title">Does WhatsApp GB Work on iPhone</h3>
                  </template>
                  <div class="intro-working">
                    No, <strong>GB WhatsApp</strong> does not work on iPhones. It is a <strong>third-party modded
                      version</strong> of
                    WhatsApp and is only
                    available for <strong>Android</strong> devices. Apple?s iOS ecosystem is more restrictive, and
                    modded apps
                    <strong>like GB WhatsApp are not
                      supported</strong> on the App Store.
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <!-- ???? -->
          <div class="apk-download-section footer-section-apk">
            <h2 class="intro-title">
              GB WhatsApp Tips & Tricks
            </h2>
            <div class="discover-features">
              Discover the best GBWhatsApp tips and tricks in 2026! Learn how to hide online status, schedule messages, download statuses, and enhance your privacy.
            </div>
            <Carousel :simple="true" :limit="4" />
            <button class="free-download-btn" @click="jump('https://gbmodshub.com/news/')">Read More GBWhatsApp
              Tips</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
// import Features from '@/components/Features.vue';
// import FAQ from '@/components/FAQ.vue';
import Carousel from '@/components/Carousel.vue';

export default {
  name: 'Home',
  components: {
    HeadNav,
    // Features,
    // FAQ,
    Carousel
  },
  data() {
    return {
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      activeNames: [],
      showapk: false,
      screenshotHeight: '400px',
      selectedFeature: null,
      apk: process.env.VUE_APP_GBLINK || null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      selectedLanguage: 'en',
      alternativeList: [
        {
          img: require('@/assets/fm-logo.webp'),
          name: 'FM WhatsApp',
          dec: 'Key Features: Customizable themes, enhanced privacy settings, dual WhatsApp accounts, and more.',
          link: 'https://gbmodshub.com/fm-whatsapp-download/',
        },
        {
          img: require('@/assets/yo-logo.webp'),
          name: 'YO WhatsApp',
          dec: 'Key Features: Anti-ban protection, extra privacy options, and the ability to hide online status and blue ticks.',
          link: 'https://gbmodshub.com/yo-whatsapp-download/',
        },
        {
          img: require('@/assets/plus-logo.webp'),
          name: 'WhatsApp Plus',
          dec: 'Key Features: Custom themes, improved media sharing options, and the ability to hide last seen and blue ticks.',
          link: 'https://gbmodshub.com/whatsapp-plus-download/',
        },
      ],
      featuresList: [
        {
          title: "Advanced Customization Options",
          desc: "Personalize themes, fonts, icons, and chat styles beyond the official WhatsApp limits.",
          img: require('@/assets/icon/icon1.webp'),
          link:'https://gbmodshub.com/advanced-customization-options-in-gb-whatsapp/',
        },
        {
          title: "Enhanced Privacy Settings",
          desc: "Hide online status, last seen, and read receipts with more flexible privacy controls.",
          img: require('@/assets/icon/icon2.webp'),
          link:'https://gbmodshub.com/enhanced-privacy-settings-in-gb-whatsapp/',
        },
        {
          title: "Dual WhatsApp Accounts",
          desc: "Run two WhatsApp accounts on one Android device without needing a second phone.",
          img: require('@/assets/icon/icon3.webp'),
          link: 'https://gbmodshub.com/dual-whatsapp-accounts-gbwhatsapp/',
        },
        {
          title: "Larger File Sharing",
          desc: "Send larger videos, documents, and media files that exceed standard WhatsApp limits.",
          img: require('@/assets/icon/icon4.webp'),
          link: 'https://gbmodshub.com/gb-whatsapp-larger-file-sharing/',
        },
        {
          title: "Multiple Media Selection",
          desc: "Select and share multiple photos or videos in one go for faster conversations.",
          img: require('@/assets/icon/icon5.webp'),
          link: 'https://gbmodshub.com/multiple-media-selection-gbwhatsapp/',
        },
        {
          title: "Built-in App Lock",
          desc: "Protect chats with fingerprint, PIN, or pattern locks built directly into the app.",
          img: require('@/assets/icon/icon6.webp'),
          link: 'https://gbmodshub.com/built-in-app-lock-gbwhatsapp/',
        },
        {
          title: "Disappearing Messages",
          desc: "Send self-destructing messages that automatically disappear after a set time.",
          img: require('@/assets/icon/icon7.webp'),
          link: 'https://gbmodshub.com/disappearing-messages-gbwhatsapp/',
        },
        {
          title: "Status Download Feature",
          desc: "Save WhatsApp Status photos and videos in one tap for later viewing.",
          img: require('@/assets/icon/icon8.webp'),
          link: 'https://gbmodshub.com/status-download-feature-gbwhatsapp/',
        },
      ],
      compareList: [
        { category: 'App Type', gb: 'Modified third-party WhatsApp client', official: 'Official WhatsApp app' },
        { category: 'Developer Support', gb: 'Maintained by third-party developers', official: 'Developed and supported by WhatsApp' },
        { category: 'Customization', gb: 'More themes, fonts, icons, and interface options', official: 'More limited customization' },
        { category: 'Privacy Controls', gb: 'Extra options may be available, depending on the version', official: 'Standard WhatsApp privacy controls' },
        { category: 'Online Status', gb: 'More options for hiding online activity', official: 'Standard online and last-seen controls' },
        { category: 'Read Receipts', gb: 'Additional controls may be available', official: 'Standard blue-tick settings' },
        { category: 'Themes', gb: 'Supports additional themes and visual customization', official: "Uses WhatsApp's official themes and appearance options" },
        { category: 'Media Sharing', gb: 'Some versions offer higher limits or additional media options', official: 'Uses official file and media limits' },
        { category: 'Chat Management', gb: 'Additional customization and management options', official: 'Standard chat features' },
        { category: 'Auto Reply', gb: 'Available in some GB WhatsApp versions', official: 'Not a standard personal-account feature' },
        { category: 'Message Scheduling', gb: 'May be available depending on the build', official: 'Not generally available as a standard feature' },
        { category: 'Multiple Accounts', gb: 'May offer additional account options depending on the version', official: 'Supports multiple accounts through official features on supported devices' },
        { category: 'Updates', gb: 'Updates depend on third-party developers', official: 'Official updates through Google Play and other supported channels' },
        { category: 'Compatibility', gb: 'Older builds may stop working after changes to WhatsApp', official: 'Designed for ongoing official compatibility' },
        { category: 'Account Stability', gb: 'Higher uncertainty because it is unofficial', official: 'More predictable and officially supported' },
        { category: 'Ban / Restriction Risk', gb: 'Greater risk because it is a modified client', official: 'Lower risk when used normally' },
        { category: 'Security', gb: 'Depends on the APK source and third-party build', official: 'Officially distributed and maintained' },
        { category: 'Customer Support', gb: 'No official WhatsApp support for the modified app', official: 'Official WhatsApp support available' },
        { category: 'Backup & Restore', gb: 'Backup methods may vary between versions', official: 'Official backup and restore system' },
        { category: 'Web / Linked Devices', gb: 'Compatibility can vary by GB WhatsApp version', official: 'Officially supported' },
        { category: 'PC Experience', gb: 'Usually requires third-party Android tools if running the Android APK on PC', official: 'Official desktop and web options' },
        { category: 'Availability', gb: 'Android-focused third-party releases', official: 'Android, iPhone, web, and desktop support' },
        { category: 'Best For', gb: 'Users who prioritize customization and extra controls', official: 'Users who prioritize reliability, security, and official support' },
      ],
      features: [{
        title: "Remove Media/File Size Caps",
        text: "Send large videos, documents, and files far beyond the official app's size limits."
      },
      {
        title: "Broadcast to Unlimited Contacts",
        text: "Reach out to a larger audience at once with unlimited broadcast capabilities."
      },
      {
        title: "Send Longer Video Statuses",
        text: "Upload videos over the standard 30-second limit for more expressive status updates."
      },
      {
        title: "Forward Messages with No Tag",
        text: "Share messages without the ?forwarded? label, keeping the chat more natural and discreet."
      },
      {
        title: "Change WhatsApp Icon",
        text: "Customize the app icon to match your home screen style or hide its presence."
      },
      {
        title: "Ghost Mode",
        text: "Stay online and view others? activities while remaining invisible to them ? the ultimate stealth feature."
      },

      ],

    };
  },
  computed: {
    downloadURL() {
      // var params = window.location.search;
      // return `/gbwhatsapp-apk-download${params}`;
      if (typeof window === 'undefined') {
        // Server-side rendering logic
        return '/gbwhatsapp-apk-download'; // Adjust this based on your server-side logic
      } else {
        // Client-side rendering logic
        let params = window.location.search;
        return `/gbwhatsapp-apk-download${params}`;
      }
    },
  },

  mounted() {
    if (window.innerWidth > 768) {
      this.screenshotHeight = '400px';
    } else {
      this.screenshotHeight = '200px';
    }
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }

    // window.adsTag.renderInterstitial(54982);
  },
  methods: {


    changeLanguage(lang) {
      console.log(lang);
      // ????????
      // ?????????????????????cookie?localStorage?
      this.$router.push({
        name: `${this.selectedLanguage}-gb`
      });
    },
    downloadClick() {
      this.$router.push({
        name: 'en-download'
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goJump() {
      window.location.href = 'https://gbmodshub.com/gbwhatsapp-ban-issues/';
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }

    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    jump(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
  height: 80px;
}

.feature-desc {
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  text-align: center;
}

.compare-table-wrap {
  overflow-x: auto;
  margin: 20px auto 30px;
  max-width: 1100px;
}

.compare-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  text-align: left;
  font-size: 14px;

  th,
  td {
    border: 1px solid #e5e5e5;
    padding: 12px 14px;
    vertical-align: top;
  }

  th {
    background: #f3f8ff;
    font-weight: 700;
  }

  tbody tr:nth-child(even) {
    background: #fafafa;
  }
}

.compare-summary,
.text-left-block {
  text-align: left;
  max-width: 960px;
}

.home-guide-list {
  margin: 16px 0;
  padding-left: 22px;
  line-height: 1.7;

  li {
    margin-bottom: 10px;
  }
}

@media (max-width: 768px) {
  ::v-deep .el-collapse-item__header {
    height: 100px;
  }
}
</style>
